import { Component, inject, input, signal } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PiDetailsModalComponent } from '../../modals/pi-details-modal/pi-details-modal.component';

@Component({
  selector: 'ark-lib-pi-badge',
  templateUrl: './pi-badge.component.html',
  styleUrl: './pi-badge.component.css',
})
export class PiBadgeComponent {
  private modalCtrl = inject(ModalController)

  show = input<boolean>(false);
  label = input<string>('IP');
  userIndex = input<number>();
  userIndexDiff = input<number>();
  userIndexAmbassador = input<number>();
  userIndexCreator = input<number>();
  userIndexHelper = input<number>();
  clickable = input<boolean>(false);

  displayModal = signal(false)

   async handleClick(event: MouseEvent) {
    event?.stopPropagation();
    
    if (!this.clickable()) return;

    const modal = await this.modalCtrl.create({
      component: PiDetailsModalComponent,
      componentProps: {
        userIndex: this.userIndex(),
        userIndexDiff: this.userIndexDiff(),
        // userIndexAmbassador: this.userIndexAmbassador(),
        // userIndexCreator: this.userIndexCreator(),
        // userIndexHelper: this.userIndexHelper(),
      },
      backdropDismiss: true,
    });

    const modalElement = modal.shadowRoot?.querySelector('.modal-wrapper') as HTMLElement;
    if (modalElement) {
      modalElement.style.width = '300px';
      modalElement.style.borderRadius = '8px';
    }

    await modal.present();

    // const { data, role } = await modal.onWillDismiss();
  }
}
